import React from "react";
import "./App.css";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle";
import Navbar from "./Navbar";
import Header from "./Header";
import HowItWorks from "./HowItWorks";
import About from "./About";
import Services from "./Services";
import Contact from "./ContactUs";
import Footer from "./Footer";
import Error404 from "./Error404";
import AllComponent from "./AllComponent";
import { BrowserRouter,Route,Routes } from "react-router-dom";
export default function App() {
  return (
    <>
  <BrowserRouter>
    <Routes>
   <Route path="/" element={ <AllComponent/>}/>
   <Route path="services" element={ <Services/>}/>
   <Route path="howitworks" element={ <HowItWorks/>}/>
   <Route path="about" element={ <About/>}/>
   <Route path="contact" element={ <Contact/>}/>
   <Route path="footer" element={ <Footer/>}/>
   <Route path="*" element={<Error404/>} />
   </Routes>
   </BrowserRouter>
   </>
   
  );
}
